import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';



export interface SnackMessage {
  message: string;

}

@Component({
  selector: 'iq-snack-message',
  templateUrl: './snack-message.component.html',
  styleUrls: ['./snack-message.component.scss']


})
export class SnackMessageComponent implements OnInit {


  constructor( private snackBar: MatSnackBar, @Inject(MAT_SNACK_BAR_DATA) public data: SnackMessage ) {

  }

  ngOnInit() {
  }

  onClose() {
    this.snackBar.dismiss();
  }
}
